import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// import Home from './components/Home';

import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ContactForm from './components/ContactForm';
import HeroSection2 from './components/HeroSection2';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ContactUs from './pages/ContactPage';
import ServicesSection from './pages/ServicesPage';
import Services from './pages/ServicesPages/Services';
import AboutUs from './pages/About';
import ContactInfo from './pages/ContactPage';
import { ServiceDetailPage, SolutionsPage } from './pages/Solutions';
import { DevOpsAutomationServices } from './pages/ServicesPages/DevOpsAuto';
import { CloudMigrationServices } from './pages/ServicesPages/CouldMigration';
import ComplianceSecurity from './pages/ServicesPages/ComplianceSecurity';
import DevOpsPlatforms from './pages/Platforms';
import PricingPage from './pages/Pricing';



function App() {
  return (
    <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactInfo />} />
          {/* <Route path="/solutions" element={<DevOpsServicesPage />} /> */}
          <Route path="/" element={<ServicesPage />} />
            <Route path="/solutions" element={<SolutionsPage />} />
            {/* <Route path="/solutions/:serviceId" element={<ServiceDetailPage />} /> */}
            <Route path="/devops-automation" element={<DevOpsAutomationServices />} />
            <Route path="/cloud-migration" element={<CloudMigrationServices />} />
            <Route path="/compliance-security" element={<ComplianceSecurity />} />
            <Route path="/platforms" element={<DevOpsPlatforms />} />

            <Route path="/pricing" element={<PricingPage />} />



        </Routes>
    </Router>
   
  );
}

export default App;
